import { apiClient } from "../../../../api/httpClient";
import { RETRIEVAL_GUARDIAN_BOND } from "../guardianFormConfig";

/**
 * @param {object} ctx
 */
export function createAddressAndFieldHandlers({
  bondKind,
  keys,
  data,
  updateData,
  dataRef,
  joinEmploymentOccupation,
}) {
  const handleGoogleCallback = (index, address, city, state, zipCode) => {
    const currentData = dataRef.current;
    const updatedGuardians = Array.isArray(currentData.guardians)
      ? [...currentData.guardians]
      : [];
    updatedGuardians[index] = {
      ...updatedGuardians[index],
      [keys.address]: address,
      [keys.city]: city,
      [keys.state]: state,
      [keys.zip]: zipCode,
    };
    updateData({ ...currentData, guardians: updatedGuardians });
  };

  const handleZipCodeChange = async (e, index) => {
    const zipCode = e.target.value;
    const updatedGuardians = [...data.guardians];
    updatedGuardians[index] = {
      ...updatedGuardians[index],
      [keys.zip]: zipCode,
    };
    updateData({ ...data, guardians: updatedGuardians });
    if (zipCode.length !== 5) return;
    try {
      const response = await apiClient(`/fields/location/${zipCode}`, "GET");
      const { city, state } = response;
      const currentData = dataRef.current;
      const freshGuardians = Array.isArray(currentData.guardians)
        ? [...currentData.guardians]
        : [];
      freshGuardians[index] = {
        ...freshGuardians[index],
        [keys.city]: city,
        [keys.state]: state,
        [keys.zip]: zipCode,
      };
      updateData({ ...currentData, guardians: freshGuardians });
    } catch (error) {
      console.error("Error fetching city/state by zip code:", error);
    }
  };

  const handleNameChange = (index, value, guardians) => {
    const updatedGuardians = [...guardians];
    const row = {
      ...updatedGuardians[index],
      [keys.name]: value,
      [keys.citizenship]: "USA",
    };
    if (bondKind === RETRIEVAL_GUARDIAN_BOND.guardianship) {
      row.country = "USA";
    } else {
      row[keys.country] = "USA";
    }
    updatedGuardians[index] = row;
    updateData({ ...data, guardians: updatedGuardians });
  };

  const handleFieldChange = (index, fieldName, value, guardians) => {
    const updatedGuardians = [...guardians];
    updatedGuardians[index] = {
      ...updatedGuardians[index],
      [fieldName]: value,
    };
    updateData({ ...data, guardians: updatedGuardians });
  };

  const handleEmploymentOccupationChange = (index, status, text, guardians) => {
    if (!joinEmploymentOccupation) return;
    const nextOccupation = joinEmploymentOccupation(status, text);
    handleFieldChange(index, keys.occupation, nextOccupation, guardians);
  };

  return {
    handleGoogleCallback,
    handleZipCodeChange,
    handleNameChange,
    handleFieldChange,
    handleEmploymentOccupationChange,
  };
}
